import { render, staticRenderFns } from "./orderItemListItem.vue?vue&type=template&id=31acad40&"
import script from "./orderItemListItem.vue?vue&type=script&lang=js&"
export * from "./orderItemListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports